export function Currency(props)
{
    return `$${((props.amount * 1) || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
}